export default ({
  column,
  yAlign,
  xAlign,

  spaceEvenly,
}) => {
  const alignment = column
    ? {
        "align-items": yAlign || "center",
        "justify-content": xAlign || "center",
      }
    : {
        "align-items": xAlign || "center",
        "justify-content": yAlign || "center",
      };
  if (spaceEvenly) {
    alignment["justify-content"] = "space-evenly";
  }

  return alignment;
};
